import {AOsApi} from '@/classes/app/api/os/a-os-api';

export class Blog extends AOsApi {
  protected _url: string = '/blog';
}
